<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-guttersclass="mb-5">
            <v-col cols="2">Parametri</v-col>
            <v-col cols="8" class="text--secondary">
              <span v-if="open" key="0">Imposta i parametri per la generazione</span>
              <span v-else key="1">
                {{ unionFiltri() }} | {{ tipoElaborazione }}    
              </span>
            </v-col>
            <v-col v-if="!open" cols="2" class="text--secondary">
              <v-btn color="success" @click.stop="onGeneraOrdine" :disabled="ordineDisabled || numeroRighe === 0">Genera ordine</v-btn>              
            </v-col>
            <v-col cols="12" sm="6" class="d-none d-md-block"></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="start" dense>
          <v-col cols="12" lg="3" md="4" sm="12">
            <date-input :label="'Esistenza al giorno'" :initDate="oggi" @change="dataEsistenza = $event" />
          </v-col>              
          <v-col md="6" lg="4">
            <v-select v-model="fornitore" :items="fornitori" outlined dense item-text="ragioneSociale" item-value="codice" label="Fornitore" return-object></v-select>
          </v-col>
        </v-row>
        <v-row justify="start" dense>
          <v-col cols="12" lg="4" md="6" sm="12">
            <v-card >
              <v-card-title>
                Categorie incluse
              </v-card-title>
              <v-card-subtitle>
                Le categorie senza selezioni sono considerate totalmente incluse
              </v-card-subtitle>
              <v-card-text>
                <v-row justify="start" dense v-for="categoriaI in elencoCategorie" :key="categoriaI.codice">
                  <v-col>
                    <v-select v-model="categorieIncluse[categoriaI.codice]"
                      :items="itemsCategoria(categoriaI.codice)"
                      dense flat outlined
                      :label="categoriaI.descrizione"
                      multiple
                      chips
                      small-chips
                      hide-no-data
                      hide-details
                      item-text="descrizione"
                      item-value="codice"
                      clearable
                      :return-object="true"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="mt-5">
              <v-card-title>
                Adeguamento ordine
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field label="Variazione percentuale ordine" v-model="correzionePercentuale" dense outlined type="number" :rules="rulesPercentuale"/>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field label="Variazione percentuale scorte" v-model="correzioneScorte" dense outlined type="number" :rules="rulesPercentuale"/>
                  </v-col>
                </v-row>
              </v-card-text>              
            </v-card>          
          </v-col>
          <v-col cols="12" lg="4" md="6" sm="12">
            <v-card>
              <v-card-title>
                Tipo elaborazione
              </v-card-title>
              <v-card-text>
                <v-radio-group v-model="tipoElaborazione" dense>
                  <v-radio label="Da scorta minima" value="scortaMinima"></v-radio>
                  <v-radio label="Da venduto settimanale" value="vendutoSettimanale"></v-radio>
                  <v-radio label="Da venduto periodo" value="vendutoPeriodo"></v-radio>
                  <v-radio label="Personalizzato" value="personalizzato"></v-radio>
                </v-radio-group>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- <v-col cols="12" lg="4" md="6" sm="12" v-if="['vendutoPeriodo', 'personalizzato'].includes(tipoElaborazione)"> -->
          <v-col cols="12" lg="4" md="6" sm="12">
            <v-card>
              <v-card-title>
                Opzioni di calcolo
              </v-card-title>
<!--               <v-card-text v-if="tipoElaborazione === 'vendutoPeriodo'">
                <date-input :label="'Inizio periodo calcolo venduto'" @change="onDataPeriodoChange('periodoDa', $event)" />
                <date-input :label="'Fine periodo calcolo venduto'" @change="onDataPeriodoChange('periodoA', $event)" />
              </v-card-text>
              <v-card-text v-if="tipoElaborazione === 'personalizzato'"> -->
              <v-card-text>
                <v-text-field label="Tra quanti giorni è prevista la consegna?" v-model="consegnaTra" dense outlined type="number" :rules="rulesPositivoNullo"/>
                <v-text-field label="Quanti giorni deve coprire l'ordine ?" v-model="ordinePerGiorni" dense outlined type="number" :rules="rulesPositivoNullo"/>
                <v-row>
                  <v-col lg="7"><v-text-field label="Di quanti giorni vanno analizzate le vendite ?" v-model="venditeStoricoGiorni" dense outlined type="number" :rules="rulesPersonalizzato" @change="onVenditeStoricoGiorni"/></v-col>
                  <v-col lg="5"><v-switch v-model="soloGiorniMovimentati" inset label="Solo giorni movimentati" title="Considera solo i giorni del periodo in cui sono presenti dei movimenti (giorni di apertura)"></v-switch></v-col>
                </v-row>
                <date-input :label="'Inizio periodo calcolo venduto'" :initDate="periodoDa" @change="onDataPeriodoChange('periodoDa', $event)" />
                <date-input :label="'Fine periodo calcolo venduto'" :initDate="periodoA" @change="onDataPeriodoChange('periodoA', $event)" />
                <v-row>
                  <v-spacer />
                  <v-col><v-switch v-model="soloProdottiMovimentati" inset label="Solo prodotti movimentati" title="Considera solo i prodotti movimentati nel periodo"></v-switch></v-col>
                </v-row>
              </v-card-text>              
            </v-card>
          </v-col>          
        </v-row>
        <v-row justify="start" dense class="mt-5 mr-5 align-end">
          <v-col cols="12" lg="2" md="2" sm="4">
            <v-btn @click.stop="onAggiungiProdotto" :disabled="ordineDisabled || numeroRighe === 0" outlined>Aggiungi prodotto</v-btn>
          </v-col>
          <v-col cols="12" lg="2" md="2" sm="4">
            <span v-if="!fornitore" class="red--text h6">E' necessario selezionare un fornitore !</span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" lg="2" md="2" sm="4">
            <v-btn @click.stop="onAnteprima" :disabled="anteprimaDisabled" outlined :loading="loading">Anteprima</v-btn>
          </v-col>
          <v-col cols="12" lg="2" md="2" sm="4">
            <v-btn color="success" @click.stop="onGeneraOrdine" :disabled="ordineDisabled || numeroRighe === 0 || !fornitore">Genera ordine</v-btn>
          </v-col>        
        </v-row>
        <dialog-conferma
          :show="dialogConferma"
          title="Confermi generazione Ordine Definitivo ?"
          :message="'L\'ordine sarà inserito nella sezione documenti'"
          @dialog-confirm="generaOrdineConfirm"
          @dialog-cancel="dialogConferma=false"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { validazioni } from '@/mixins/validazioni.js'
  import DateInput from '@/components/dateInput.vue'
  import DialogConferma from '@/components/dialogConferma'
  import configurazioni from '@/services/configurazioniService.js'
  import clienti from '@/services/clientiService.js'
  import tabacchi from '@/services/custom/tabacchiService.js'

  export default {
    components: {
      DialogConferma,
      DateInput
    },
    mixins: [
      validazioni
    ],
    props: {
      numeroRighe: { type: Number, default: 0 }
    },
    data: (vm) => ({
      panel: 0,
      settoriInseriti: [],
      fornitori: [],
      fornitore: null,
      dataFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataEsistenza: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      settore: null,
      noteLettura: '',
      menuStart: false,
      modal: false,
      totaleDati: 0,
      nomeFile: '',
      dialogConferma: false,
      triggerReset: 0,
      elencoCategorie: [],
      categorie: {},
      categorieIncluse: {},
      dItemsCategoria: {},
      tipoElaborazione: 'scortaMinima',
      consegnaTra: 1,
      ordinePerGiorni: 7,
      venditeStoricoGiorni: 7,
      correzionePercentuale: 0,
      correzioneScorte: 0,
      periodoDa: null,
      periodoA: null,
      soloGiorniMovimentati: false,
      soloProdottiMovimentati: true,
      anteprimaDisabled: false,
      ordineDisabled: true,
      impostazioni: null,
      loading: false,
      infoParametri: null
    }),
    async mounted() {
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.impostazioni = backoffice.ordiniPeriodici || {}
      const prodotti_categorie = await configurazioni.getConfigurazione('prodotti_categorie')

      this.elencoCategorie = prodotti_categorie.labelCategorie.filter(x => x.codice !== 'categoria4').map(x => { // filtro per debug, lasciare le categorie definite dal cliente
        return {
          codice: x.codice,
          descrizione: x.descrizione
        }
      })
      const categorie = prodotti_categorie.categorie
      const tipi = _.uniq(categorie.map(x => x.tipo)).sort()
      for (let tipo of tipi) {
        const items = categorie.filter(x => x.tipo === tipo)
        this.$set(this.dItemsCategoria, tipo, items)

        if (this.impostazioni[tipo]) {
          this.categorieIncluse[tipo] = categorie.filter(x => this.impostazioni[tipo].includes(x.codice))
        }
      }

      this.fornitori = await clienti.getFornitori()

      if (this.impostazioni.fornitore) {
        this.fornitore = this.fornitori.find(x => x.codice === this.impostazioni.fornitore)
      } else {
        this.fornitore = this.fornitori.length > 0 ? this.fornitori[0] : null
      }
      this.onChangeTipoElaborazione()
    },
    computed: {
      computedDataFormatted () {
        return this.formatDate(this.dataEsistenza)
      },
      importaDisabled() {
        return !this.settore || this.totaleDati === 0
      },
      rulesPersonalizzato() {
        let rl = []
        rl.push(this.rules.required)
        rl.push(this.rules.numeropositivo)
        return rl
      },
      rulesPositivoNullo() {
        let rl = []
        rl.push(this.rules.required)
        rl.push(this.rules.numeropositivonullo)
        return rl
      },      
      rulesPercentuale() {
        let rl = []
        rl.push(this.rules.required)
        rl.push(this.rules.numero)
        return rl
      },
      oggi() {
        return (new Date()).toISOString().substring(0, 10)
      }
    },
    watch: {
      dataEsistenza (val) {
        this.dataFormatted = this.formatDate(this.dataEsistenza)
      },
      tipoElaborazione() {
        this.onChangeTipoElaborazione()
      }      
    },
    methods: {
      unionFiltri() {
        let categorie = ''
        for (let c of Object.keys(this.categorieIncluse)) {
          let cc = this.categorieIncluse[c]
          if (cc.length > 0) {
            categorie = (categorie.length > 0 ? categorie + ', ' : '') + cc.map(x => x.descrizione).join(', ')
          }
        }
        return categorie
      },      
      itemsCategoria(codice) {
        return codice && this.dItemsCategoria[codice] ? this.dItemsCategoria[codice] : []
      },
/*       onChangeCategorie() {
        this.$emit('selezione', { incluse: this.categorieIncluse, escluse: this.categorieEscluse })
      }, */
      onFornitoreChanged(item) {
        this.fornitoreItem = item
      },
      onDataPeriodoChange(name, value) {
        this[name] = value
        this.calcolaDurata()
      },
      calcolaDurata() {
        const durata = moment(this.periodoDa).isValid() && moment(this.periodoA).isValid() ? moment(this.periodoA).diff(this.periodoDa, 'days') : null
        this.venditeStoricoGiorni = durata
      },
      onChangeTipoElaborazione() {
        console.log('onChangeTipoElaborazione')
        const impostazioni = _.get(this.impostazioni, `riordino.${this.tipoElaborazione}`)
        this.consegnaTra = impostazioni.consegnaTra || 1
        this.ordinePerGiorni = impostazioni.ordinePerGiorni || 7
        switch(this.tipoElaborazione) {
          case 'scortaMinima':
            this.consegnaTra = 0
            this.ordinePerGiorni = 0
            this.periodoDa = moment().add(-8, 'days').format('YYYY-MM-DD')
            this.periodoA = moment().add(-1, 'days').format('YYYY-MM-DD')
            break
         case 'vendutoSettimanale':
            this.periodoDa = moment().add(-8, 'days').format('YYYY-MM-DD')
            this.periodoA = moment().add(-1, 'days').format('YYYY-MM-DD')
            break
         case 'vendutoPeriodo':
            this.periodoDa = null
            this.periodoA = null
            break
         case 'personalizzato':
            this.consegnaTra = null
            this.ordinePerGiorni = null
            this.periodoDa = null
            this.periodoA = null
            break
          default:
            break
        }
        this.calcolaDurata()
      },
      onVenditeStoricoGiorni() {
        this.periodoDa = moment().add(-this.venditeStoricoGiorni, 'days').format('YYYY-MM-DD')
        this.periodoA = moment().add(-1, 'days').format('YYYY-MM-DD')        
      },
      getDatiCalcolo() {
        var dati = {
          tipoElaborazione: this.tipoElaborazione,
          dataEsistenza: this.dataEsistenza,
          categorieIncluse: this.categorieIncluse,
          periodoDa: this.periodoDa,
          periodoA: this.periodoA,
          consegnaTra: this.consegnaTra,
          ordinePerGiorni: this.ordinePerGiorni,
          venditeStoricoGiorni: this.venditeStoricoGiorni,
          correzionePercentuale: this.correzionePercentuale,
          correzioneScorte: this.correzioneScorte,
          soloGiorniMovimentati: this.soloGiorniMovimentati,
          soloProdottiMovimentati: this.soloProdottiMovimentati
        }
        return dati
      },
      async generaOrdine(modalita) {
/*         var dati = {
          tipoElaborazione: this.tipoElaborazione,
          dataEsistenza: this.dataEsistenza,
          categorieIncluse: this.categorieIncluse,
          periodoDa: this.periodoDa,
          periodoA: this.periodoA,
          consegnaTra: this.consegnaTra,
          ordinePerGiorni: this.ordinePerGiorni,
          venditeStoricoGiorni: this.venditeStoricoGiorni,
          correzionePercentuale: this.correzionePercentuale,
          correzioneScorte: this.correzioneScorte,
          soloGiorniMovimentati: this.soloGiorniMovimentati,
          soloProdottiMovimentati: this.soloProdottiMovimentati
        } */
        const dati = this.getDatiCalcolo()
        let elenco = await tabacchi.generaOrdine(dati, modalita)
        let completi = elenco.map((x, idx) => { return { idx, ...x, calc: x.pezzi } })
        return completi
      },
      onAggiungiProdotto() {
        this.$emit('aggiungiProdotto', this.getDatiCalcolo())
      },
      async onAnteprima() {
        this.loading = true
        const dati = await this.generaOrdine('anteprima')
        this.loading = false
        this.ordineDisabled = false
        this.$emit('elabora', dati)
      },
      onGeneraOrdine() {
        this.dialogConferma = true
      },
      async generaOrdineConfirm() {
        this.dialogConferma = false
        this.ordineDisabled = true
        const tipoOrdine = this.impostazioni.tipoOrdine || 'ordineFornitore'
        this.$emit('creaOrdine', tipoOrdine, this.fornitore, this.impostazioni.fiscale)
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
</style>